// src/components/merchant/MerchantCharts.js
// Graphiques du marchand : revenus, commandes, vues
// Maxula

import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  BarElement, Title, Tooltip, Legend, Filler
} from 'chart.js';
import { Line, Bar } from 'react-chartjs-2';
import { merchantAPI } from '../../services/api';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend, Filler);

const baseOpts = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
};

const MerchantCharts = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const res = await merchantAPI.charts(); setData(res.data?.data || null); }
      catch (e) {} finally { setLoading(false); }
    })();
  }, []);

  if (loading) {
    return <div className="bg-white rounded-xl border border-gray-200 p-5 mb-6 h-40 flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600" /></div>;
  }
  if (!data) return null;

  const primary = '#db2777';
  const blue = '#2563eb';

  const revenueData = {
    labels: data.labels,
    datasets: [{
      label: 'Revenu (MAD)', data: data.revenue,
      borderColor: primary, backgroundColor: 'rgba(219,39,119,0.12)',
      fill: true, tension: 0.35, pointRadius: 3
    }]
  };
  const ordersData = {
    labels: data.labels,
    datasets: [{ label: 'Commandes', data: data.orders, backgroundColor: blue, borderRadius: 6 }]
  };
  const hasViews = (data.topViews || []).some((d) => d.views > 0);
  const viewsData = {
    labels: (data.topViews || []).map((d) => (d.name.length > 16 ? d.name.slice(0, 16) + '…' : d.name)),
    datasets: [{ label: 'Vues', data: (data.topViews || []).map((d) => d.views), backgroundColor: '#7c3aed', borderRadius: 6 }]
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-6">
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <h3 className="font-semibold text-gray-900 mb-3">Revenus (6 derniers mois)</h3>
        <div className="h-56"><Line data={revenueData} options={baseOpts} /></div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5">
        <h3 className="font-semibold text-gray-900 mb-3">Commandes (6 derniers mois)</h3>
        <div className="h-56"><Bar data={ordersData} options={baseOpts} /></div>
      </div>
      <div className="bg-white rounded-xl border border-gray-200 p-5 lg:col-span-2">
        <h3 className="font-semibold text-gray-900 mb-3">Annonces les plus vues</h3>
        {hasViews ? (
          <div className="h-56"><Bar data={viewsData} options={{ ...baseOpts, indexAxis: 'y' }} /></div>
        ) : (
          <div className="text-center text-gray-400 py-10">Pas encore de vues sur vos annonces.</div>
        )}
      </div>
    </div>
  );
};

export default MerchantCharts;
